import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { eur, fmtDate } from "../sampling/common";

const LAB_CAT = "Produzione/Confezione";
const addDays = (iso, n) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + n); return d.toLocaleDateString("sv-SE"); };

export function useLabs() {
  const [labs, setLabs] = useState([]);
  useEffect(() => { api.get("/suppliers").then(r => setLabs([...r.data].sort((a, b) => (b.category === LAB_CAT) - (a.category === LAB_CAT)))).catch(() => {}); }, []);
  return labs;
}

export function LabFields({ lab, setLab, pieces, startDate, disabled }) {
  const labs = useLabs();
  const l = lab || {};
  const set = (patch) => setLab({ ...l, ...patch });
  const total = (Number(l.cost_per_piece) || 0) * (Number(pieces) || 0);
  const eta = startDate && l.lead_days ? addDays(startDate, Number(l.lead_days)) : null;
  return (
    <div className="border p-4 mt-5" style={{ borderColor: "var(--border)" }} data-testid="lab-fields">
      <div className="label-caps mb-3">Laboratorio esterno · taglio e confezione</div>
      <div className="grid md:grid-cols-4 gap-3">
        <div className="md:col-span-2"><label className="text-xs opacity-70 block mb-1">Laboratorio</label>
          <select disabled={disabled} className="input-dark" value={l.supplier_id || ""} onChange={e => set({ supplier_id: e.target.value || null, name: labs.find(s => s.id === e.target.value)?.name || null })} data-testid="lab-select">
            <option value="">Nessuno</option>
            {labs.map(s => <option key={s.id} value={s.id}>{s.name}{s.category === LAB_CAT ? "" : ` · ${s.category || "altro"}`}</option>)}
          </select></div>
        <div><label className="text-xs opacity-70 block mb-1">Costo al pezzo (€)</label>
          <input disabled={disabled} type="number" min="0" step="0.01" className="input-dark" value={l.cost_per_piece ?? ""} onChange={e => set({ cost_per_piece: e.target.value === "" ? null : Number(e.target.value) })} data-testid="lab-cost"/></div>
        <div><label className="text-xs opacity-70 block mb-1">Giorni di lavorazione</label>
          <input disabled={disabled} type="number" min="0" className="input-dark" value={l.lead_days ?? ""} onChange={e => set({ lead_days: e.target.value === "" ? null : Number(e.target.value) })} data-testid="lab-days"/></div>
      </div>
      <input disabled={disabled} placeholder="Note per il laboratorio" className="input-dark mt-3" value={l.notes || ""} onChange={e => set({ notes: e.target.value })} data-testid="lab-notes"/>
      <div className="text-xs mt-3 opacity-80 flex flex-wrap gap-4">
        <span data-testid="lab-total">Costo lavorazione: <b>{eur(total)}</b>{pieces ? ` (${pieces} pz)` : ""}</span>
        {eta && <span data-testid="lab-eta">Consegna stimata: <b>{fmtDate(eta)}</b> (dal taglio + {l.lead_days} gg)</span>}
      </div>
    </div>
  );
}

export const labPayload = (l) => (l && (l.supplier_id || l.name) ? l : { supplier_id: null, name: null });
